module.exports = __webpack_public_path__ + "static/media/guardian-leaf-right.4efd09fc.webp";